import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import IncidentDetail from "./ui";

const IncidentMainDetail = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <IncidentDetail />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default IncidentMainDetail;
